import get from 'lodash/get';

export default (student: unknown, notification: string, step: number) => {
    if (get(student, `preferences.notifications.${notification}${step}`)) {
        return false;
    }
    for (let i = step - 1; i > 0; i--) {
        if (!get(student, `preferences.notifications.${notification}${i}`)) {
            return false;
        }
    }

    return true;
};
